import { render, staticRenderFns } from "./ContactBody.vue?vue&type=template&id=3b0d4627&"
import script from "./ContactBody.vue?vue&type=script&lang=js&"
export * from "./ContactBody.vue?vue&type=script&lang=js&"
import style0 from "./ContactBody.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports